// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1246":"565eaf33","9345":"65c5d427"}[chunkId] + ".chunk.css";
};